import { render, staticRenderFns } from "./CreateUserAccount.vue?vue&type=template&id=9cc4f96a&"
import script from "./CreateUserAccount.vue?vue&type=script&lang=js&"
export * from "./CreateUserAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports